import { useContext, useEffect, useState } from 'react'
import { useLocalStorage } from 'react-use'

import { Button } from '@wartek-id/button-v1'
import { Icon } from '@wartek-id/icon-v2'
import { Text } from '@wartek-id/text-v1'

import KinerjaCoachMark from 'app/KinerjaTimPenilaiPSPage/components/CoachMark'
import { OnboardingContext } from 'app/KinerjaTimPenilaiPSPage/components/Penetapan/Onboarding/OnboardingContext'
import { STEPS } from 'app/KinerjaTimPenilaiPSPage/components/Penetapan/Onboarding/steps'

export function OnboardingInfoButton() {
  const context = useContext(OnboardingContext)

  // Ensure that the component is used within the correct context provider
  if (!context)
    throw new Error(
      '<OnboardingPenetapan.OnboardingInfoButton> must be used within a <OnboardingPenetapan.Provider>'
    )

  const { setOnboardingMode } = context

  return (
    <Button
      variant="ghost"
      size="lg"
      className="!bg-white flex items-center space-x-1"
      onClick={() => {
        setOnboardingMode(true)
      }}
    >
      <Icon color="inherit">help</Icon>
      <Text as="span" variant="action" color="inherit">
        Tata Cara
      </Text>
    </Button>
  )
}

export function Onboarding() {
  const storageKey = 'kinerja-ps-penetapan-form-onboarding-done'
  const context = useContext(OnboardingContext)

  // Ensure that the component is used within the correct context provider
  if (!context)
    throw new Error(
      '<OnboardingPenetapan.Onboarding> must be used within a <OnboardingPenetapan.Provider>'
    )

  // ------------------------------------
  // Get context data and its derivatives
  // ------------------------------------
  const { setStepIndex, onboardingMode, setOnboardingMode } = context

  const [isCoachMarkOpen, setIsCoachMarkOpen] = useState(false)

  // On the first time visit, set onboarding mode to true
  // and mark it as visited in local storage.
  // Check if the user has visited the page before.
  const [hasDoneOnboarding, setHasDoneOnboarding] = useLocalStorage(
    storageKey,
    false
  )

  // If the user has not visited the page before,
  // start the onboarding mode.
  useEffect(() => {
    if (!hasDoneOnboarding) {
      setOnboardingMode(true)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [hasDoneOnboarding])

  useEffect(() => {
    if (onboardingMode) {
      setIsCoachMarkOpen(true)
    }
  }, [onboardingMode])

  return (
    <KinerjaCoachMark
      tooltipSeparation={24}
      // Moving target is enabled in order to track the elements. Without
      // this, the coach mark will not follow correctly positioned tooltip
      // and mask element. Behind the scene, it sets up a timer with
      // updateInterval as the interval.
      movingTarget={true}
      updateInterval={10}
      steps={STEPS}
      resetOnClose
      customDescriptionRenderer={(description, { stepIndex, allSteps }) => {
        return (
          <div className="space-y-2">
            <Text variant="heading-md">
              {stepIndex + 1}/{allSteps.length}
            </Text>
            <Text variant="body-lg">{description}</Text>
          </div>
        )
      }}
      disableAutoScroll={true}
      maskPadding={0}
      onNext={(stepIndex) => {
        setStepIndex(stepIndex + 1)
      }}
      onPrev={(stepIndex) => {
        setStepIndex(stepIndex - 1)
      }}
      isOpen={isCoachMarkOpen}
      onClose={() => {
        setStepIndex(0)

        setIsCoachMarkOpen(false)
        setOnboardingMode(false)

        // mark the user as visited
        if (!hasDoneOnboarding) {
          setHasDoneOnboarding(true)
        }
      }}
    />
  )
}
